import { useRef } from 'react';

import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import {
  ITooltipPortalProps,
  TooltipPortalContentDirection,
  TooltipPortalPosition,
} from '@ui/tooltip-portal/tooltip-portal-types';
import useIsClipped from '@/utils/use-is-clipped';
import Text from './text';
import { TextProps } from './text.types';

type TTextClippedTooltipProps = {
  text: string;
  tooltipText: string;
  textProps?: TextProps;
  tooltipTextProps?: TextProps;
  tooltipPortalProps?: Partial<ITooltipPortalProps>;
};

const TextClippedTooltip = ({
  text,
  tooltipText,
  textProps,
  tooltipTextProps,
  tooltipPortalProps,
}: TTextClippedTooltipProps) => {
  const ref = useRef<HTMLElement | null>(null);

  const isClipped = useIsClipped({ ref });

  return (
    <TooltipPortal
      animationType="slide-up"
      styles={{ padding: '2px 4px' }}
      tailHorizontalPosition={0}
      verticalOffset={-4}
      delayStart={250}
      contentDirection={TooltipPortalContentDirection.LTR}
      position={TooltipPortalPosition.TOP}
      /* order matters, everything below the props spread is specific to allow this component to work */
      {...tooltipPortalProps}
      disabled={!isClipped || tooltipPortalProps?.disabled}
      childrenWrapperClass="width-100-percent"
      tooltipWrapperClass="width-100-percent"
      tooltipContent={
        <Text color="var(--gray-true-dark-100)" className="P2" {...tooltipTextProps}>
          {tooltipText}
        </Text>
      }
    >
      {/* order matters, everything after the props spread is specific to allow this component to work */}
      <Text {...textProps} clamp={1} ref={ref} maxWidth="max-content">
        {text}
      </Text>
    </TooltipPortal>
  );
};

export default TextClippedTooltip;
